import { Component, OnInit, ViewChild } from '@angular/core';
import { UsuariosService } from '../../services/usuarios.service';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { PerfilesService } from '../../services/perfiles.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {
  showModalUsuario:boolean=false
  headersUsuarios:any[]=[]
  listUsuarios:any[]=[]
  listPerfiles:any[]=[]
  inputsModalUsuario:any[]=[]

  paginationUsuarios:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  @ViewChild("paginationUsuarios",{static:false}) paginadorUsuarios:PaginationComponent;

  constructor(
    private usuariosService:UsuariosService,
    private perfilesService:PerfilesService
    ) {
      this.headersUsuarios=[
        {
          label: "Nombre",
          key: "nombre",
          subKey:"",
          customClass: "",
          type:""
        },
        {
          label: "Correo",
          key: "correo",
          subKey:"",
          customClass: "",
          type:""
        },
        {
          label: "Usuario",
          key: "login",
          subKey:"",
          customClass: "",
          type:""
        },
        {
          label: "Nro Documento",
          key: "nro_documento",
          subKey:"",
          customClass: "",
          type:""
        },
        {
          label: "Anexo",
          key: "anexo",
          subKey:"",
          customClass: "",
          type:""
        },
        {
          label: "Agencia",
          key: "agencia",
          subKey:"agencia",
          customClass: "",
          type:""
        },
        {
          label: "Perfil",
          key: "perfil",
          subKey:"nombre_perfil",
          customClass: "",
          type:""
        },

      ]

      
    }

  ngOnInit() {
    this.usuariosService.getUsuarios("page=1&options=1").subscribe((data:any)=>{
      this.listUsuarios=data.usuarios.docs
      this.paginationUsuarios.hasNextPage=data.usuarios.hasNextPage
      this.paginationUsuarios.hasPrevPage=data.usuarios.hasPrevPage
      this.paginationUsuarios.totalPages=new Array(data.usuarios.totalPages)
      this.paginationUsuarios.page=data.usuarios.page
      this.paginadorUsuarios.pagParams=this.paginationUsuarios
    })

    this.perfilesService.getPerfiles("page=1&options=1").subscribe((data:any)=>{
      
      let perfiles:any=data.perfiles.filter((e:any)=>{
        return e._id!="63dfe9b31f3709c77a5d0c8c"
      })

      perfiles=perfiles.map((e:any)=>{
        return {
          value:e._id,
          option:e.nombre_perfil
        }
      })

      this.listPerfiles=perfiles
      this.inputsModalUsuario=[
        {
          "label":"Nombre y Apellido",
          "placeholder":"Escribir nombre y apellido",
          "type":"text",
          "id":"nombre_usuario",
          "optionsForSelect":[]
        },
        {
          "label":"Correo",
          "placeholder":"Escribir correo",
          "type":"text",
          "id":"correo_usuario",
          "optionsForSelect":[]
        },
        {
          "label":"Usuario/Login",
          "placeholder":"Escribir usuario/login",
          "type":"text",
          "id":"login_usuario",
          "optionsForSelect":[]
        },
        {
          "label":"Contraseña",
          "placeholder":"Escribir contraseña",
          "type":"password",
          "id":"password_usuario",
          "optionsForSelect":[]
        },
        {
          "label":"Agencia",
          "placeholder":"..Seleccionar agencia",
          "type":"select",
          "id":"agencia_usuario",
          "optionsForSelect":[
            {
              "option":"Campo RZ",
              "value":"63f165983298c1f1a4690be0"
            },
            {
              "option":"Interno",
              "value":"63eee0a1d8cbbceb81e8ede9"
            },
            {
              "option":"Finaleg",
              "value":"63f165a83298c1f1a4690be1"
            },
            {
              "option":"Cancelados",
              "value":"63f165b33298c1f1a4690be2"
            },
            {
              "option":"Agencia Vidal",
              "value":"63f165bf3298c1f1a4690be3"
            },
            {
              "option":"Reclamos",
              "value":"63f165dc3298c1f1a4690be4"
            },
            {
              "option":"Sin cartera",
              "value":"63f165e83298c1f1a4690be5"
            }
          ]
        },
        {
          "label":"Perfil",
          "placeholder":"..Seleccionar perfil",
          "type":"select",
          "id":"perfil_usuario",
          "optionsForSelect":perfiles
        },
        {
          "label":"Nro Documento",
          "placeholder":"Escribir nro documento",
          "type":"text",
          "id":"documento_usuario",
          "optionsForSelect":[]
        },
        {
          "label":"Anexo",
          "placeholder":"Escribir anexo",
          "type":"text",
          "id":"anexo_usuario",
          "optionsForSelect":[]
        },
      ]
    })
  }

  refreshPageUsuarios(page:any){
    this.usuariosService.getUsuarios("page="+page+"&options=1").subscribe((data:any)=>{
      this.listUsuarios=data.usuarios.docs
      this.paginationUsuarios.hasNextPage=data.usuarios.hasNextPage
      this.paginationUsuarios.hasPrevPage=data.usuarios.hasPrevPage
      this.paginationUsuarios.totalPages=new Array(data.usuarios.totalPages)
      this.paginationUsuarios.page=data.usuarios.page
      this.paginadorUsuarios.pagParams=this.paginationUsuarios
    })
  }

  addUsuario(e:any){
    let nombre_usuario:any=document.querySelector("#nombre_usuario")
    let correo_usuario:any=document.querySelector("#correo_usuario")
    let login_usuario:any=document.querySelector("#login_usuario")
    let password_usuario:any=document.querySelector("#password_usuario")
    let agencia_usuario:any=document.querySelector("#agencia_usuario")
    let perfil_usuario:any=document.querySelector("#perfil_usuario")
    let nro_documento:any=document.querySelector("#documento_usuario")
    let anexo:any=document.querySelector("#anexo_usuario")


    if(
      nombre_usuario.value=="" ||
      correo_usuario.value=="" ||
      login_usuario.value=="" ||
      password_usuario.value=="" ||
      agencia_usuario.value=="" ||
      perfil_usuario.value==""
    ){
      return false
    }

    let dataSend:any={
      nombre:nombre_usuario.value,
      correo:correo_usuario.value,
      login:login_usuario.value,
      password_:password_usuario.value,
      agencia:agencia_usuario.value,
      perfil:perfil_usuario.value,
      nro_documento:nro_documento.value,
      anexo:anexo.value,
    }

    this.usuariosService.addUsuario(dataSend).subscribe((data:any)=>{
      
      if(data.error!=""){
        alert("Usuario ó correo ya esta registrado!")
        return false
      }
      this.refreshPageUsuarios(1)
      this.closeModal()
     
    })
  }

  closeModal(){
    this.showModalUsuario=false
  }

}
